import * as settingsService from '@features/settings/services/settingService';

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useSettingsQuery = () => {
  return useQuery({
    queryKey: ["settings"],
    queryFn: settingsService.getSettings,
  });
};

export const useUpdateSetting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: settingsService.updateSetting,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["settings"] });
    },
    onError: (error) => {
      console.error("Error updating settings:", error);
    },
  });
};

export const usePricingQuery = (params) => {
  const searchParams = new URLSearchParams(params);
  return useQuery({
    queryKey: ["pricing", params],
    queryFn: () => settingsService.getPricing(searchParams.toString()),
    enabled:
      searchParams.has("city") &&
      searchParams.has("userId"),
  });
};

export const useFiles = (params) => {
  const searchParams = new URLSearchParams(params);
  return useQuery({
    queryKey: ["files", params],
    queryFn: () => settingsService.getFiles(searchParams.toString()),
  });
};
